import React, { useState } from 'react';
interface BrandLogoProps {
  src: string;
  className?: string;
  wordmarkClassName?: string;
}

/** Madison Mortgage logo with a clean Poppins wordmark fallback if the image fails. */
export function BrandLogo({
  src,
  className = '',
  wordmarkClassName = ''
}: BrandLogoProps) {
  const [failed, setFailed] = useState(false);
  if (failed) {
    return <span className={`whitespace-nowrap font-sans font-semibold tracking-tight text-[#0b1857] ${wordmarkClassName}`} role="img" aria-label="Madison Mortgage" data-id="element-842" data-mp="115dlavaahxbg">
        Madison Mortgage
      </span>;
  }
  return <img src={src} alt="Madison Mortgage" onError={() => setFailed(true)} className={className} data-id="element-843" data-mp="rfu03iz3trdf" />;
}